import {
  GET_FIELD_OFFICE_SUCCESSFULLY, GET_FIELD_OFFICE_FAILED, ADD_FIELD_OFFICE_SUCCESSFULLY,
  ADD_FIELD_OFFICE_FAILED, CLOSE_FIELD_OFFICE_SUCCESSFULLY, CLOSE_FIELD_OFFICE_FAILED,
  EDIT_FIELD_OFFICE_SUCCESSFULLY, EDIT_FIELD_OFFICE_FAILED, UPDATE_FIELD_OFFICE_SUCCESSFULLY,
  UPDATE_FIELD_OFFICE_FAILED, UPDATE_FIELD_ADDON_SUCCESSFULLY, UPDATE_FIELD_ADDON_FAILED,
  ADD_FIELD_ALERT_SUCCESSFULLY, ADD_FIELD_ALERT_FAILED, GET_FIELD_ALERT_SUCCESSFULLY, GET_FIELD_ALERT_FAILED,
  UPDATE_FIELD_ALERT_FAILED, UPDATE_FIELD_ALERT_SUCCESSFULLY, GET_STANDARD_CLEANING_SUCCESSFULLY,
  GET_STANDARD_CLEANING_FAILED, UPDATE_STANDARD_CLEANING_SUCCESSFULLY, UPDATE_STANDARD_CLEANING_FAILED,
  GET_INITIAL_CLEANING_SUCCESSFULLY, GET_INITIAL_CLEANING_FAILED, ADD_INITIAL_CLEANING_SUCCESSFULLY,
  ADD_INITIAL_CLEANING_FAILED, DELETE_INITIAL_CLEANING_SUCCESSFULLY, DELETE_INITIAL_CLEANING_FAILED,
  LOGIN_STRIPE_SUCCESSFULLY, LOGIN_STRIPE_FAILED, LOGIN_QUICKBOOK, LOGIN_QUICKBOOK_FAILED,
  LOGIN_CALLBACK_QUICKBOOK, LOGIN_CALLBACK_QUICKBOOK_FAILED, GET_COLLECTION_DETAIL, GET_COLLECTION_DETAIL_FAILED,
  GET_ADDON_COLLECTION_DETAIL, GET_ADDON_COLLECTION_DETAIL_FAILED, GET_DASHBOARD_STAT, GET_DASHBOARD_STAT_FAILED,
  GET_CUSTOMER_MATRIX, GET_CUSTOMER_MATRIX_FAILED, GET_CUSTOMER_MATRIX_V1, GET_CUSTOMER_MATRIX_V1_FAILED, 
  GET_OPTIMOROUTE_KEY_SUCCESSFULLY, GET_OPTIMOROUTE_KEY_FAILED, UPDATE_OPTIMOROUTE_KEY_SUCCESSFULLY, UPDATE_OPTIMOROUTE_KEY_FAILED, 
  GET_STAX_KEYS_SUCCESSFULLY, GET_STAX_KEYS_FAILED, UPDATE_STAX_KEYS_SUCCESSFULLY, UPDATE_STAX_KEYS_FAILED,
  GET_PULSEM_KEYS_SUCCESSFULLY, GET_PULSEM_KEYS_FAILED, UPDATE_PULSEM_KEYS_SUCCESSFULLY, UPDATE_PULSEM_KEYS_FAILED,
  GET_ZIP_CODES_FAILED, GET_ZIP_CODES_SUCCESSFULLY, UPDATE_FILED_CLEAN_SUCESSFULLY, UPDATE_FILED_CLEAN_FAILED, 
  SAVE_AREA_SUCESSFULLY, SAVE_AREA_FAILED, GET_NEXT_10_DAYS_INITIAL_CLEANING_DATA_SUCESSFULLY, 
  GET_NEXT_10_DAYS_INITIAL_CLEANING_DATA_FAILED, GET_ALL_INITIAL_CLEANING_DATA_SUCESSFULLY, GET_ALL_INITIAL_CLEANING_DATA_FAILED,
  GET_SERVICE_NOTIFICATION_KEYS_SUCCESSFULLY, GET_SERVICE_NOTIFICATION_KEYS_FAILED,
  UPDATE_SERVICE_NOTIFICATION_KEYS_SUCCESSFULLY, UPDATE_SERVICE_NOTIFICATION_KEYS_FAILED
} from '../types';
import axiosInstance from '../../Lib/axios';


// get user of detail
export const getFieldOffice = (params) => {
  return (dispatch) => {
    return axiosInstance
      .get(`/field-office/`, { params })
      .then((response) => {
        dispatch({
          type: GET_FIELD_OFFICE_SUCCESSFULLY,
          data: response.data,
        });
      })
      .catch((error) => {
        if (error && error.response) {
          if (error.response.status === 401 || error.response.status === 403) {
            // window.location.assign('/')
            // localStorage.clear();
            // sessionStorage.clear();
          }
          if (error.response) {
            dispatch({
              type: GET_FIELD_OFFICE_FAILED,
              data: error.response.data,
            });
          }
        }
      });
  };
};

//Add new franchise
export const addFieldOffice = (params) => {
  return (dispatch) => {
    return axiosInstance
      .post(`/field-office/`, params)
      .then((response) => {
        dispatch({
          type: ADD_FIELD_OFFICE_SUCCESSFULLY,
          data: response.data,
        });
      })
      .catch((error) => {
        if (error && error.response) {
          if (error.response.status === 401 || error.response.status === 403) {
            window.location.assign('/')
            localStorage.clear();
            sessionStorage.clear();
          }
          if (error.response) {
            dispatch({
              type: ADD_FIELD_OFFICE_FAILED,
              data: error.response.data,
            });
          }
        }
      });
  };
};

//Close Franchise
export const closeFieldOffice = (uuid) => {
  return (dispatch) => {
    return axiosInstance
      .get(`/field-office/${uuid}/activate-franchise/`, {})
      .then(() => {
        dispatch({
          type: CLOSE_FIELD_OFFICE_SUCCESSFULLY,
          data: { 'message': 'deleted' },
        });
      })
      .catch((error) => {
        if (error && error.response) {
          if (error.response.status === 401 || error.response.status === 403) {
            window.location.assign('/')
            localStorage.clear();
            sessionStorage.clear();
          }
          if (error.response) {
            dispatch({
              type: CLOSE_FIELD_OFFICE_FAILED,
              data: error.response.data,
            });
          }
        }
      });
  };
};

//Update franchise Details
export const editFieldOffice = (uuid) => {
  return (dispatch) => {
    return axiosInstance
      .get(`/field-office/${uuid}/`, {})
      .then((response) => {
        dispatch({
          type: EDIT_FIELD_OFFICE_SUCCESSFULLY,
          data: response.data,
        });
      })
      .catch((error) => {
        if (error && error.response) {
          if (error.response.status === 401 || error.response.status === 403) {
            window.location.assign('/')
            localStorage.clear();
            sessionStorage.clear();
          }
          if (error.response) {
            dispatch({
              type: EDIT_FIELD_OFFICE_FAILED,
              data: error.response.data,
            });
          }
        }
      });
  };
};

//Get franchise Details
export const updateFieldOffice = (params, uuid) => {
  return (dispatch) => {
    return axiosInstance
      .patch(`/field-office/${uuid}/`, params, {})
      .then((response) => {
        dispatch({
          type: UPDATE_FIELD_OFFICE_SUCCESSFULLY,
          data: response.data,
        });
      })
      .catch((error) => {
        if (error && error.response) {
          if (error.response.status === 401 || error.response.status === 403) {
            window.location.assign('/')
            localStorage.clear();
            sessionStorage.clear();
          }
          if (error.response) {
            dispatch({
              type: UPDATE_FIELD_OFFICE_FAILED,
              data: error.response.data,
            });
          }
        }
      });
  };
};


//Get franchise Details
export const updateFieldAddOn = (params) => {
  return (dispatch) => {
    return axiosInstance
      .patch(`/field-office-addon/${params?.uuid}/`, params, {})
      .then((response) => {
        dispatch({
          type: UPDATE_FIELD_ADDON_SUCCESSFULLY,
          data: response.data,
        });
      })
      .catch((error) => {
        if (error && error.response) {
          if (error.response.status === 401 || error.response.status === 403) {
            window.location.assign('/')
            localStorage.clear();
            sessionStorage.clear();
          }
          if (error.response) {
            dispatch({
              type: UPDATE_FIELD_ADDON_FAILED,
              data: error.response.data,
            });
          }
        }
      });
  };
};

//Add Field Alert
export const addFieldAlert = (params) => {
  return (dispatch) => {
    return axiosInstance
      .post(`/field-office-alert/`, params)
      .then((response) => {
        dispatch({
          type: ADD_FIELD_ALERT_SUCCESSFULLY,
          data: response.data,
        });
      })
      .catch((error) => {
        if (error && error.response) {
          if (error.response.status === 401 || error.response.status === 403) {
            window.location.assign('/')
            localStorage.clear();
            sessionStorage.clear();
          }
          if (error.response) {
            dispatch({
              type: ADD_FIELD_ALERT_FAILED,
              data: error.response.data,
            });
          }
        }
      });
  };
};

//Get Field Alert
export const getFieldAlert = (params) => {
  return (dispatch) => {
    return axiosInstance
      .get(`/field-office-alert/`, { params })
      .then((response) => {
        dispatch({
          type: GET_FIELD_ALERT_SUCCESSFULLY,
          data: response.data,
        });
      })
      .catch((error) => {
        if (error && error.response) {
          if (error.response.status === 401 || error.response.status === 403) {
            window.location.assign('/')
            localStorage.clear();
            sessionStorage.clear();
          }
          if (error.response) {
            dispatch({
              type: GET_FIELD_ALERT_FAILED,
              data: error.response.data,
            });
          }
        }
      });
  };
};

//Update Field Alert
export const updateFieldAlert = (params) => {
  return (dispatch) => {
    return axiosInstance
      .patch(`/field-office-alert/${params.uuid}/`, params, {})
      .then((response) => {
        dispatch({
          type: UPDATE_FIELD_ALERT_SUCCESSFULLY,
          data: response.data,
        });
      })
      .catch((error) => {
        if (error && error.response) {
          if (error.response.status === 401 || error.response.status === 403) {
            window.location.assign('/')
            localStorage.clear();
            sessionStorage.clear();
          }
          if (error.response) {
            dispatch({
              type: UPDATE_FIELD_ALERT_FAILED,
              data: error.response.data,
            });
          }
        }
      });
  };
};

//Get Standard Cleaning
export const getStandardCleaning = (params) => {
  return (dispatch) => {
    return axiosInstance
      .get(`/pricing-matrix/`, { params })
      .then((response) => {
        dispatch({
          type: GET_STANDARD_CLEANING_SUCCESSFULLY,
          data: response.data,
        });
      })
      .catch((error) => {
        if (error && error.response) {
          if (error.response.status === 401 || error.response.status === 403) {
            window.location.assign('/')
            localStorage.clear();
            sessionStorage.clear();
          }
          if (error.response) {
            dispatch({
              type: GET_STANDARD_CLEANING_FAILED,
              data: error.response.data,
            });
          }
        }
      });
  };
};

//Update Standard Cleaning
export const updateStandardCleaning = (params) => {
  return (dispatch) => {
    return axiosInstance
      .patch(`/pricing-matrix/pricing-matrix/`, params, {})
      .then((response) => {
        dispatch({
          type: UPDATE_STANDARD_CLEANING_SUCCESSFULLY,
          data: response.data,
        });
      })
      .catch((error) => {
        if (error && error.response) {
          if (error.response.status === 401 || error.response.status === 403) {
            window.location.assign('/')
            localStorage.clear();
            sessionStorage.clear();
          }
          if (error.response) {
            dispatch({
              type: UPDATE_STANDARD_CLEANING_FAILED,
              data: error.response.data,
            });
          }
        }
      });
  };
};

//Add Intial Cleaning 
export const addIntialCleaning = (params) => {
  console.log("params:::>", params)

  return (dispatch) => {
    return axiosInstance
      .post(`/field-office-initial-cleaning/`, params)
      .then((response) => {
        dispatch({
          type: ADD_INITIAL_CLEANING_SUCCESSFULLY,
          data: response.data,
        });
      })
      .catch((error) => {
        if (error && error.response) {
          if (error.response.status === 401 || error.response.status === 403) {
            window.location.assign('/')
            localStorage.clear();
            sessionStorage.clear();
          }
          if (error.response) {
            dispatch({
              type: ADD_INITIAL_CLEANING_FAILED,
              data: error.response.data,
            });
          }
        }
      });
  };
};


//Get Intial Cleaning
export const getIntialCleaning = (params) => {
  return (dispatch) => {
    return axiosInstance
      .get(`/field-office-initial-cleaning/`, { params })
      .then((response) => {
        dispatch({
          type: GET_INITIAL_CLEANING_SUCCESSFULLY,
          data: response.data,
        });
      })
      .catch((error) => {
        if (error && error.response) {
          if (error.response.status === 401 || error.response.status === 403) {
            window.location.assign('/')
            localStorage.clear();
            sessionStorage.clear();
          }
          if (error.response) {
            dispatch({
              type: GET_INITIAL_CLEANING_FAILED,
              data: error.response.data,
            });
          }
        }
      });
  };
};

//Delete Intial Cleaning
export const deleteIntialCleaning = (params) => {
  return (dispatch) => {
    return axiosInstance
      .delete(`/field-office-initial-cleaning/${params}`, {})
      .then(() => {
        dispatch({
          type: DELETE_INITIAL_CLEANING_SUCCESSFULLY,
          data: { 'message': 'deleted' },
        });
      })
      .catch((error) => {
        if (error && error.response) {
          if (error.response.status === 401 || error.response.status === 403) {
            window.location.assign('/')
            localStorage.clear();
            sessionStorage.clear();
          }
          if (error.response) {
            dispatch({
              type: DELETE_INITIAL_CLEANING_FAILED,
              data: error.response.data,
            });
          }
        }
      });
  };
};


//Stripe Login
export const loginWithStripe = (uuid) => {
  return (dispatch) => {
    return axiosInstance
      .get(`/field-office/${uuid}/stripe-connect-link/`, {})
      .then((response) => {
        dispatch({
          type: LOGIN_STRIPE_SUCCESSFULLY,
          data: response.data,
        });
      })
      .catch((error) => {
        if (error && error.response) {
          if (error.response.status === 401 || error.response.status === 403) {
            window.location.assign('/')
            localStorage.clear();
            sessionStorage.clear();
          }
          if (error.response) {
            dispatch({
              type: LOGIN_STRIPE_FAILED,
              data: error.response.data,
            });
          }
        }
      });
  };
};

/////////////////////// quick book integration
// login with quickbook
export const loginWithQuickbook = (uuid, params) => {
  return (dispatch) => {
    return axiosInstance
      .get(`/field-office/${uuid}/quickbooks-oauth/`, {params} )
      .then((response) => {
        dispatch({
          type: LOGIN_QUICKBOOK,
          data: response.data,
        });
      })
      .catch((error) => {
        if (error && error.response) {
          if (error.response.status === 401 || error.response.status === 403) {
            window.location.assign('/')
            localStorage.clear();
            sessionStorage.clear();
          }
          if (error.response) {
            dispatch({
              type: LOGIN_QUICKBOOK_FAILED,
              data: error.response,
            });
          }
        }
      });
  };
};

// quick callback api
export const loginCallbackQuickbook = (uuid, params) => {
  return (dispatch) => {
    return axiosInstance
      .get(`/field-office/${uuid}/quickbooks-oauth-callback/${params}`)
      .then((response) => {
        dispatch({
          type: LOGIN_CALLBACK_QUICKBOOK,
          data: response.data,
        });
      })
      .catch((error) => {
        if (error && error.response) {
          if (error.response.status === 401 || error.response.status === 403) {
            window.location.assign('/')
            localStorage.clear();
            sessionStorage.clear();
          }
          if (error.response) {
            dispatch({
              type: LOGIN_CALLBACK_QUICKBOOK_FAILED,
              data: error.response.data,
            });
          }
        }
      });
  };
};
//////////////////////////////////////////////////////

////////////////// franchise overview apis /////////////////////////////
// get collection detail
export const getCollectionDetail = (params) => {
  return (dispatch) => {
    return axiosInstance
      .get(`/field-office-collection-detail-v1/${params}`)
      .then((response) => {
        dispatch({
          type: GET_COLLECTION_DETAIL,
          data: response.data,
        });
      })
      .catch((error) => {
        if (error && error.response) {
          if (error.response.status === 401 || error.response.status === 403) {
            window.location.assign('/')
            localStorage.clear();
            sessionStorage.clear();
          }
          if (error.response) {
            dispatch({
              type: GET_COLLECTION_DETAIL_FAILED,
              data: error.response.data,
            });
          }
        }
      });
  };
};

// get collection detail
export const getAddOnCollectionDetail = (params) => {
  return (dispatch) => {
    return axiosInstance
      .get(`/field-office-addon-collection-v1/${params}`)
      .then((response) => {
        dispatch({
          type: GET_ADDON_COLLECTION_DETAIL,
          data: response.data,
        });
      })
      .catch((error) => {
        if (error && error.response) {
          if (error.response.status === 401 || error.response.status === 403) {
            window.location.assign('/')
            localStorage.clear();
            sessionStorage.clear();
          }
          if (error.response) {
            dispatch({
              type: GET_ADDON_COLLECTION_DETAIL_FAILED,
              data: error.response.data,
            });
          }
        }
      });
  };
};

// get dashboard  state
export const getDashboardStat = (params) => {
  return (dispatch) => {
    return axiosInstance
      .get(`/field-office-dashboard-v1/dashboard_stats/${params}`)
      .then((response) => {
        dispatch({
          type: GET_DASHBOARD_STAT,
          data: response.data,
        });
      })
      .catch((error) => {
        if (error && error.response) {
          if (error.response.status === 401 || error.response.status === 403) {
            window.location.assign('/')
            localStorage.clear();
            sessionStorage.clear();
          }
          if (error.response) {
            dispatch({
              type: GET_DASHBOARD_STAT_FAILED,
              data: error.response.data,
            });
          }
        }
      });
  };
};

// get customer matrix
export const getCustomerMatrix = (params) => {
  return (dispatch) => {
    return axiosInstance
      .get(`/field-office-dashboard-v1/${params}`)
      .then((response) => {
        dispatch({
          type: GET_CUSTOMER_MATRIX,
          data: response.data,
        });
      })
      .catch((error) => {
        if (error && error.response) {
          if (error.response.status === 401 || error.response.status === 403) {
            window.location.assign('/')
            localStorage.clear();
            sessionStorage.clear();
          }
          if (error.response) {
            dispatch({
              type: GET_CUSTOMER_MATRIX_FAILED,
              data: error.response.data,
            });
          }
        }
      });
  };
};

// get customer matrix
export const getCustomerMatrix_v1 = (params) => {
  return (dispatch) => {
    return axiosInstance
      .get(`/field-office-dashboard-v1/${params}`)
      .then((response) => {
        dispatch({
          type: GET_CUSTOMER_MATRIX_V1,
          data: response.data,
        });
      })
      .catch((error) => {
        if (error && error.response) {
          if (error.response.status === 401 || error.response.status === 403) {
            window.location.assign('/')
            localStorage.clear();
            sessionStorage.clear();
          }
          if (error.response) {
            dispatch({
              type: GET_CUSTOMER_MATRIX_V1_FAILED,
              data: error.response.data,
            });
          }
        }
      });
  };
};
///////////////////////////////////////////////////////////////////////

export const getOptimorouteKey = (params) => {
  return (dispatch) => {
    return axiosInstance
      .get(`field-office-app-setup/?uuid=${params}`)
      .then((response) => {
        dispatch({
          type: GET_OPTIMOROUTE_KEY_SUCCESSFULLY,
          data: response.data,
        });
      })
      .catch((error) => {
        if (error && error.response) {
          if (error.response.status === 401 || error.response.status === 403) {
            window.location.assign('/')
            localStorage.clear();
            sessionStorage.clear();
          }
          if (error.response) {
            dispatch({
              type: GET_OPTIMOROUTE_KEY_FAILED,
              data: error.response.data,
            });
          }
        }
      });
  };
};

export const updateOptimorouteKey = (params) => {
  return (dispatch) => {
    return axiosInstance
      .patch(`field-office-app-setup/${params.uuid}/`, {
        optimoroute_api_key: params.optimoroute_api_key
      })
      .then((response) => {
        dispatch({
          type: UPDATE_OPTIMOROUTE_KEY_SUCCESSFULLY,
          data: response.data,
        });
      })
      .catch((error) => {
        if (error && error.response) {
          if (error.response.status === 401 || error.response.status === 403) {
            window.location.assign('/')
            localStorage.clear();
            sessionStorage.clear();
          }
          if (error.response) {
            dispatch({
              type: UPDATE_OPTIMOROUTE_KEY_FAILED,
              data: error.response.data,
            });
          }
        }
      });
  };
};

export const getStaxKeys = (params) => {
  return (dispatch) => {
    return axiosInstance
      .get(`field-office-app-setup/${params}`)
      .then((response) => {
        dispatch({
          type: GET_STAX_KEYS_SUCCESSFULLY,
          data: response.data,
        });
      })
      .catch((error) => {
        if (error && error.response) {
          if (error.response.status === 401 || error.response.status === 403) {
            window.location.assign('/')
            localStorage.clear();
            sessionStorage.clear();
          }
          if (error.response) {
            dispatch({
              type: GET_STAX_KEYS_FAILED,
              data: error.response.data,
            });
          }
        }
      });
  };
};

export const updateStaxKeys = (params,uuid) => {
  return (dispatch) => {
    return axiosInstance
      .patch(`/field-office-app-setup/${uuid}/`, params, {})
      .then((response) => {
        dispatch({
          type: UPDATE_STAX_KEYS_SUCCESSFULLY,
          data: response.data,
        });
      })
      .catch((error) => {
        if (error && error.response) {
          if (error.response.status === 401 || error.response.status === 403) {
            window.location.assign('/')
            localStorage.clear();
            sessionStorage.clear();
          }
          if (error.response) {
            dispatch({
              type: UPDATE_STAX_KEYS_FAILED,
              data: error.response.data,
            });
          }
        }
      });
  };
};

export const getPulseMKeys = (params) => {
  return (dispatch) => {
    return axiosInstance
      .get(`field-office-app-setup/${params}`)
      .then((response) => {
        dispatch({
          type: GET_PULSEM_KEYS_SUCCESSFULLY,
          data: response.data,
        });
      })
      .catch((error) => {
        if (error && error.response) {
          if (error.response.status === 401 || error.response.status === 403) {
            window.location.assign('/')
            localStorage.clear();
            sessionStorage.clear();
          }
          if (error.response) {
            dispatch({
              type: GET_PULSEM_KEYS_FAILED,
              data: error.response.data,
            });
          }
        }
      });
  };
};

export const updatePulseMKeys = (params,uuid) => {
  return (dispatch) => {
    return axiosInstance
      .patch(`/field-office-app-setup/${uuid}/`, params, {})
      .then((response) => {
        dispatch({
          type: UPDATE_PULSEM_KEYS_SUCCESSFULLY,
          data: response.data,
        });
      })
      .catch((error) => {
        if (error && error.response) {
          if (error.response.status === 401 || error.response.status === 403) {
            window.location.assign('/')
            localStorage.clear();
            sessionStorage.clear();
          }
          if (error.response) {
            dispatch({
              type: UPDATE_PULSEM_KEYS_FAILED,
              data: error.response.data,
            });
          }
        }
      });
  };
};

export const getAllZipCodes = (params) => {
  return (dispatch) => {
    return axiosInstance
      .get(`field-office/zip_codes/?franchises_uuid=${params.uuid}`)
      .then((response) => {
        dispatch({
          type: GET_ZIP_CODES_SUCCESSFULLY,
          data: response.data,
        });
      })
      .catch((error) => {
        if (error && error.response) {
          if (error.response.status === 401 || error.response.status === 403) {
            window.location.assign('/')
            localStorage.clear();
            sessionStorage.clear();
          }
          if (error.response) {
            dispatch({
              type: GET_ZIP_CODES_FAILED,
              data: error.response.data,
            });
          }
        }
      });
  };
}

export const getAllInitialCleaningData = (params) => {
  return (dispatch) => {
    return axiosInstance
      .get(`field-office-base-cleaning-v2/?field_office__uuid=${params.uuid}&limit=1000`)
      .then((response) => {
        dispatch({
          type: GET_ALL_INITIAL_CLEANING_DATA_SUCESSFULLY,
          data: response.data,
        });
      })
      .catch((error) => {
        if (error && error.response) {
          if (error.response.status === 401 || error.response.status === 403) {
            window.location.assign('/')
            localStorage.clear();
            sessionStorage.clear();
          }
          if (error.response) {
            dispatch({
              type: GET_ALL_INITIAL_CLEANING_DATA_FAILED,
              data: error.response.data,
            });
          }
        }
      });
  };
}


export const getNextTenDaysInitialCleaningData = (params) => {
  
  //function to convert date to string YYYY-MM-DD
  const convertDateToString = (date) => {
    var d = new Date(date),
      month = '' + (d.getMonth() + 1),
      day = '' + d.getDate(),
      year = d.getFullYear();
  
    if (month.length < 2) month = '0' + month;
    if (day.length < 2) day = '0' + day;
  
    return [year, month, day].join('-');
  };

  // function to add days to date object
  const addDays = (date, days) => {
    var result = new Date(date);
    result.setDate(result.getDate() + days);
    return result;
  }

  return (dispatch) => {
    return axiosInstance
      .get(`/field-office-initial-cleaning-v2/?base_initial_clean__field_office__uuid=${params.uuid}&cleaning_date__gte=${convertDateToString(new Date())}&cleaning_date__lte=${convertDateToString(addDays(new Date(), 9))}`)
      .then((response) => {
        dispatch({
          type: GET_NEXT_10_DAYS_INITIAL_CLEANING_DATA_SUCESSFULLY,
          data: response.data,
        });
      })
      .catch((error) => {
        if (error && error.response) {
          if (error.response.status === 401 || error.response.status === 403) {
            window.location.assign('/')
            localStorage.clear();
            sessionStorage.clear();
          }
          if (error.response) {
            dispatch({
              type: GET_NEXT_10_DAYS_INITIAL_CLEANING_DATA_FAILED,
              data: error.response.data,
            });
          }
        }
      });
  };
}

export const saveArea = (params) => {
  return (dispatch) => {
    return axiosInstance
      .post(`field-office-base-cleaning-v2/`, params)
      .then((response) => {
        dispatch({
          type: SAVE_AREA_SUCESSFULLY,
          data: response.data,
        });
      })
      .catch((error) => {
        if (error && error.response) {
          if (error.response.status === 401 || error.response.status === 403) {
            window.location.assign('/')
            localStorage.clear();
            sessionStorage.clear();
          }
          if (error.response) {
            dispatch({
              type: SAVE_AREA_FAILED,
              data: error.response.data,
            });
          }
        }
      });
  };
}

export const updateCleaningField = ({UUID, params}) => {
  return (dispatch) => {
    return axiosInstance
      .patch(`field-office-initial-cleaning-v2/${UUID}/`, params)
      .then((response) => {
        dispatch({
          type: UPDATE_FILED_CLEAN_SUCESSFULLY,
          data: response.data,
        });
      })
      .catch((error) => {
        if (error && error.response) {
          if (error.response.status === 401 || error.response.status === 403) {
            window.location.assign('/')
            localStorage.clear();
            sessionStorage.clear();
          }
          if (error.response) {
            dispatch({
              type: UPDATE_FILED_CLEAN_FAILED,
              data: error.response.data,
            });
          }
        }
      });
  };
}

export const clearError = (error_name) => {
  return (dispatch) => {
    dispatch({
      type: "CLEAR_ERROR",
      data: error_name,
    })
  };
}

export const getServiceNotificationKeys = (params) => {
  return (dispatch) => {
    return axiosInstance
      .get(`field-office-app-setup/${params}`)
      .then((response) => {
        dispatch({
          type: GET_SERVICE_NOTIFICATION_KEYS_SUCCESSFULLY,
          data: response.data,
        });
      })
      .catch((error) => {
        if (error && error.response) {
          if (error.response.status === 401 || error.response.status === 403) {
            window.location.assign('/')
            localStorage.clear();
            sessionStorage.clear();
          }
          if (error.response) {
            dispatch({
              type: GET_SERVICE_NOTIFICATION_KEYS_FAILED,
              data: error.response.data,
            });
          }
        }
      });
  };
};

export const updateServiceNotificationKeys = (params,uuid) => {
  return (dispatch) => {
    return axiosInstance
      .patch(`/field-office-app-setup/${uuid}/`, params, {})
      .then((response) => {
        dispatch({
          type: UPDATE_SERVICE_NOTIFICATION_KEYS_SUCCESSFULLY,
          data: response.data,
        });
      })
      .catch((error) => {
        if (error && error.response) {
          if (error.response.status === 401 || error.response.status === 403) {
            window.location.assign('/')
            localStorage.clear();
            sessionStorage.clear();
          }
          if (error.response) {
            dispatch({
              type: UPDATE_SERVICE_NOTIFICATION_KEYS_FAILED,
              data: error.response.data,
            });
          }
        }
      });
  };
};